import { NUTRITION_JOURNAL } from "../types/actions";

const initialState = {
	journalNutritionalSummary: [],
	journalNutritionalEntries: [],
	nutritionGoals: [],
	hydration: []
};

export default (state = initialState, action) => {
	switch (action.type) {
		case NUTRITION_JOURNAL.GET_NUTRITION_JOURNAL_SUMMARY:
			return { ...state, journalNutritionalSummary: action.payload };
		case NUTRITION_JOURNAL.GET_NUTRITION_JOURNAL_ENTRIES:
			return { ...state, journalNutritionalEntries: action.payload };
		case NUTRITION_JOURNAL.EDIT_NUTRITION_JOURNAL:
			return { ...state, journalNutritionalEntries: action.payload };
		case NUTRITION_JOURNAL.DELETE_NUTRITION_JOURNAL:
			return { ...state, journalNutritionalEntries: action.payload };
		case NUTRITION_JOURNAL.GET_NUTRITION_GOALS:
			return { ...state, nutritionGoals: action.payload };
		case NUTRITION_JOURNAL.CREATE_NUTRITION_GOALS:
			return { ...state, nutritionGoals: action.payload };
		case NUTRITION_JOURNAL.UPDATE_HYDRATION:
			return { ...state, hydration: action.payload };
		default:
			return state;
	}
};
